import { Circle, XCircle, CheckCircle } from '../../icons/SvgIcons'
import { useEffect } from 'react'

const passwordRules = {
  minLength: (pw: string) => pw.length >= 12,
  upperCase: (pw: string) => /[A-Z]/.test(pw),
  number: (pw: string) => /[0-9]/.test(pw),
  specialChar: (pw: string) => /[!@#$%^&*(),.?":{}|<>]/.test(pw),
}

type PasswordValidationProps = Readonly<{
  password: string
  setValidPassword?: React.Dispatch<React.SetStateAction<boolean>>
}>

export function PasswordValidation({
  password,
  setValidPassword,
}: PasswordValidationProps) {
  const isValid = {
    minLength: passwordRules.minLength(password),
    upperCase: passwordRules.upperCase(password),
    number: passwordRules.number(password),
    specialChar: passwordRules.specialChar(password),
  }

  const rules = [
    {
      label: 'Minimum 12 characters',
      valid: isValid.minLength,
    },
    {
      label: 'At least one upper case letter',
      valid: isValid.upperCase,
    },
    {
      label: 'At least one number',
      valid: isValid.number,
    },
    {
      label: (
        <>
          At least one special character (e.g., !@#$%^&
          <span style={{ fontFamily: 'Arial, sans-serif' }}>*</span>)
        </>
      ),
      valid: isValid.specialChar,
    },
  ]

  useEffect(() => {
    if (!setValidPassword) return

    const allValid = Object.values(isValid).every(Boolean)
    setValidPassword(allValid)
  }, [
    isValid.minLength,
    isValid.upperCase,
    isValid.number,
    isValid.specialChar,
  ])

  return (
    <div className="flex flex-col items-star gap-1 text-sm">
      <p className="text-left font-medium text-gray-700">
        Password requirements:
      </p>
      <ul className="">
        {rules.map((rule, index) => (
          <li key={index} className="flex items-center gap-1">
            {password ? (rule.valid ? CheckCircle() : XCircle()) : Circle()}
            <span
              className={
                password
                  ? rule.valid
                    ? 'text-cyan-500'
                    : 'text-rose-500'
                  : 'text-gray-550'
              }
            >
              {rule.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
